<template>
    <div :class="preCls + 'content-box'">
        <Tabs class="router-view" :animated="false" v-model="active">
            <TabPane
                v-for="item in tabs"
                :key="item.name"
                :label="item.meta.title"
                :name="item.name"
            >
                <Access :name="item.name">
                    <router-view
                        v-if="active == item.name"
                        :name="item.meta.uri"
                    />
                </Access>
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
import mTab from '@/views/common/m-tab'

export default {
    mixins: [mTab],
    data() {
        return { active: this.$cache.active }
    },
}
</script>
